import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DEMO } from '@athlete-x/definitions';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ifDemo]',
    standalone: true
})
export class IfDemoDirective {
    private _showIfDemo = true;
    protected _isVisible = false;

    @Input() set ifDemo(show: boolean) {
        this._showIfDemo = show;
        this._update();
    }

    constructor(
        protected template: TemplateRef<any>,
        protected entry: ViewContainerRef,
        @Inject(DEMO) protected _isDemo: boolean
    ) {
        this._update();
    }


    protected get _shouldRender() {
        return this._isDemo ? this._showIfDemo : true;
    }

    protected _update() {
        if (!this._shouldRender) {
            if (this._isVisible) {
                this.entry.clear();
                this._isVisible = false;
            }

        } else if (!this._isVisible) {
            this.entry.createEmbeddedView(this.template);
            this._isVisible = true;
        }
    }
}
